const BASE_API = process.env.REACT_APP_ROUTE_API;
const headers = {Accept: 'application/json','Content-Type': 'application/json'};

export default {
      listarAnuidadeAluno: async (ano, token) => {
        try {
          const user = JSON.parse(localStorage.getItem('user'));
          let req;
            req = await fetch(`${BASE_API}anuidade/3/` + ano + `/` + user.id + `?token=` + token, {
              method: 'GET',
              headers: headers
            });
          const json = await req.json();
                json.statusRetorno = req.status;
          return json;
        } catch (error) {
          return error;
        }
      },
      pagamento: async (data, token) => {
        try {
          let req;
            req = await fetch(`${BASE_API}anuidade/pagamento?token=` + token, {
              method: 'POST',
              headers: headers,
              body: JSON.stringify(data)
            });
          const json = await req.json();
                json.statusRetorno = req.status;
          return json;
        } catch (error) {
          return error;
        }
      }
};